import {InputLabel, MenuItem, Select} from '@mui/material';
import {Reason} from './SupplierDeclineBookingModal';
import {SupplierBookingDisableModalContent} from "../../styles";

interface SelectProps {
    declineReasons: [Reason];
    handleSelectReason: (e:any) => void;
    selectedReason: Reason | undefined;
}

const DeclineBookingReasonSelect = (props: SelectProps) => {
    const {declineReasons, handleSelectReason, selectedReason} = props;

    return <SupplierBookingDisableModalContent variant='standard'>
        <InputLabel id="ss-decline-booking-reason-select-label">Reason</InputLabel>
        <Select
                labelId='ss-decline-booking-reason-select-label'
                id='ss-decline-booking-reason-select'
                name={'declineBookingReason'}
                value={selectedReason?.key || ''}
                onChange={handleSelectReason}
                fullWidth
            >
                {declineReasons?.map((reason: Reason ) => <MenuItem key={reason.key} value={reason.key}>{reason.value}</MenuItem>)}
            </Select>
    </SupplierBookingDisableModalContent>
}

export default DeclineBookingReasonSelect;
